import { useMutation } from '@tanstack/react-query';
import useWorkspaceSystem from '../systems/useWorkspaceSystem';
import { WorkspaceInvitation, WorkspaceJSON } from '../types';
import { WorkspaceQueryInvalidator } from './queryInvalidator';

type Params = {
	workspaceID: number;
	onSuccess?: ( workspace: WorkspaceJSON ) => void;
	onError?: ( error: unknown ) => void;
};

const useInviteWorkspaceMembersMutation = ( { workspaceID, onSuccess, onError }: Params ) => {
	const system = useWorkspaceSystem();

	return useMutation(
		async (
			{ invites }: { invites: WorkspaceInvitation[] }
		) => system.inviteWorkspaceMembers( { workspaceID, invites } ),
		{
			onSuccess: ( workspace ) => {
				WorkspaceQueryInvalidator.invalidateMemberAddOnPreview( workspaceID );
				WorkspaceQueryInvalidator.invalidateWorkspaceMembers( workspaceID );
				onSuccess?.( workspace );
			},
			onError
		}
	);
};

export default useInviteWorkspaceMembersMutation;
